import type { User } from "../types";

interface UserTableProps {
  users: User[];
  selected: Set<number>;
  onToggleSelect: (id: number) => void;
  onSelectAll: () => void;
}

export function UserTable({ users, selected, onToggleSelect, onSelectAll }: UserTableProps) {
  const allSelected = users.length > 0 && selected.size === users.length;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gradient-to-r from-[#f0e8ff] to-[#e0d0ff] border-b border-gray-200">
              <th className="p-3 text-left">
                <input type="checkbox" checked={allSelected} onChange={onSelectAll}
                  className="rounded border-gray-300 text-[#5716a8] focus:ring-[#985ae6]" />
              </th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Photo</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Name</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Age</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">School</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Class</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Phone</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Ward</th>
              <th className="p-3 text-left font-semibold text-gray-600 text-xs uppercase tracking-wider">Status</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan={9} className="p-12 text-center text-gray-400">
                  <div className="text-4xl mb-2">📋</div>
                  <p>No users found matching your filters</p>
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.id} className={`border-b border-gray-100 hover:bg-purple-50/50 transition-colors ${selected.has(user.id) ? "bg-purple-50/70" : ""}`}>
                  <td className="p-3">
                    <input type="checkbox" checked={selected.has(user.id)} onChange={() => onToggleSelect(user.id)}
                      className="rounded border-gray-300 text-[#5716a8] focus:ring-[#985ae6]" />
                  </td>
                  <td className="p-3">
                    {user.profile_image ? (
                      <img src={user.profile_image} alt="" className="w-9 h-9 rounded-full object-cover ring-2 ring-gray-100" />
                    ) : (
                      <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#f0e8ff] to-[#e0d0ff] flex items-center justify-center text-[#5716a8] text-sm font-bold">
                        {user.name.charAt(0)}
                      </div>
                    )}
                  </td>
                  <td className="p-3 font-medium text-gray-900">{user.name}</td>
                  <td className="p-3 text-gray-600">{user.age}</td>
                  <td className="p-3 text-gray-600 max-w-[160px] truncate" title={user.school_name}>{user.school_name}</td>
                  <td className="p-3 text-gray-600">{user.student_class}</td>
                  <td className="p-3 text-gray-600">{user.phone}</td>
                  <td className="p-3 text-gray-600">{user.city}</td>
                  <td className="p-3">
                    {user.is_winner ? (
                      <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold bg-gradient-to-r from-amber-50 to-yellow-50 text-amber-700 border border-amber-200">
                        ⚽ Winner
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-400">
                        Pending
                      </span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}